import React from 'react';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const QuoteFilters = ({ 
  filters, 
  onFilterChange, 
  onClearFilters,
  onCreateQuote 
}) => {
  const handleInputChange = (field, value) => {
    onFilterChange({ ...filters, [field]: value });
  };

  return (
    <div className="bg-card rounded-lg shadow-elevation-2 p-4 md:p-6 mb-4 md:mb-6">
      <div className="flex flex-col lg:flex-row lg:items-end gap-4">
        <div className="flex-1 grid grid-cols-1 md:grid-cols-3 gap-4">
          <Input
            type="search"
            label="Buscar"
            placeholder="Cliente, teléfono, folio, vehículo..."
            value={filters?.search}
            onChange={(e) => handleInputChange('search', e?.target?.value)}
          />

          <Input
            type="date"
            label="Fecha desde"
            value={filters?.dateFrom}
            onChange={(e) => handleInputChange('dateFrom', e?.target?.value)}
          />

          <Input
            type="date"
            label="Fecha hasta"
            value={filters?.dateTo}
            onChange={(e) => handleInputChange('dateTo', e?.target?.value)}
          />
        </div>

        <div className="flex flex-col sm:flex-row gap-2">
          <Button
            variant="outline"
            onClick={onClearFilters}
            iconName="X"
            iconPosition="left"
            className="w-full sm:w-auto"
          >
            Limpiar
          </Button>
          <Button
            variant="default"
            onClick={onCreateQuote}
            iconName="Plus"
            iconPosition="left"
            className="w-full sm:w-auto"
          >
            Nueva Cotización
          </Button>
        </div>
      </div>
    </div>
  );
};

export default QuoteFilters;